/** localStorage key for login API `data.access` string[] */
export const ACCESS_STORAGE_KEY = "access";

/**
 * @returns {string[]|null} Parsed list, or null if unset (legacy sessions: use full role-based menu).
 */
export function readAccessListFromStorage() {
  try {
    const raw = localStorage.getItem(ACCESS_STORAGE_KEY);
    if (raw == null || raw === "") return null;
    const p = JSON.parse(raw);
    if (!Array.isArray(p)) return null;
    return p.map((x) => String(x).trim()).filter(Boolean);
  } catch {
    return null;
  }
}

/**
 * When access list exists, module is visible only if any candidate name matches (case-insensitive).
 * When accessList is null, caller should fall back to role-based rules.
 */
export function matchesAccessModule(accessList, ...candidates) {
  if (accessList == null) return true;
  const set = new Set(accessList.map((a) => String(a).toLowerCase().trim()));
  return candidates.some((c) => set.has(String(c).toLowerCase().trim()));
}
